/**
 * Menu script
 */
class ATS_Menu {
    constructor() {
        this.initEvents();
    }

    initEvents() {
        let menuWrapper = $('.site-header .wrapper-menu');
        let menuIcon = menuWrapper.find('.menu-toggle');
        let menuBlock = menuWrapper.find('.menu');

        if (menuIcon.length) {
            menuIcon.on('click', function (e) {
                e.preventDefault();
                menuBlock.toggleClass('is-active');
            });
        }
    }
}